import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { Tea } from '@/data/teas';
import type { TraceRecord } from '@/data/batches';

// Mock API - Replace with real API endpoints when available
export const teaApi = createApi({
  reducerPath: 'teaApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
  tagTypes: ['Tea', 'Batch'],
  endpoints: (builder) => ({
    // These endpoints are mocked for now
    // When you have a real API, update the endpoints accordingly
    getTeas: builder.query<Tea[], void>({
      queryFn: async () => {
        // Import data directly for static build
        const { teas } = await import('@/data/teas');
        return { data: teas };
      },
      providesTags: ['Tea'],
    }),
    getTeaBySlug: builder.query<Tea | undefined, string>({
      queryFn: async (slug) => {
        const { getTea } = await import('@/data/teas');
        const tea = getTea(slug);
        return tea ? { data: tea } : { error: { status: 404, data: 'Tea not found' } };
      },
      providesTags: (_result, _error, slug) => [{ type: 'Tea', id: slug }],
    }),
    getBatches: builder.query<TraceRecord[], void>({
      queryFn: async () => {
        const { traceLibrary } = await import('@/data/batches');
        return { data: Object.values(traceLibrary) };
      },
      providesTags: ['Batch'],
    }),
  }),
});

export const { 
  useGetTeasQuery, 
  useGetTeaBySlugQuery, 
  useGetBatchesQuery 
} = teaApi;
